export const SEARCH_URL = '/results';
